/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { formatDay, formatMonth } from 'Utils';
import { logEvent } from 'AppManager';
import Theme from '../../../../Theme';
import { Device } from 'DeviceUtils';

export const dayOfWeek = (date, day) => new Date(+date + day * (1000 * 60 * 60 * 24)).getDay();
export const futureMonth = (date, day) => new Date(+date + day * (1000 * 60 * 60 * 24)).getMonth();

const days = [];
const daysBack = 10;
const daysForward = 10;

const DayText = ({ day, now, active, styles }) => (
    <>
        <span
            style={{
                ...styles.centerText,
                fontSize: 30,
                color: day === active ? '#EBEBEB' : '#6c6c6c',
                letterSpacing: -0.3
            }}
        >
            {`${formatDay(dayOfWeek(now, day), 2)}.`}
        </span>
        <span
            style={{
                ...styles.centerText,
                color: day === active ? '#EBEBEB' : '#6c6c6c',
                fontSize: 15,
                letterSpacing: 0.4
            }}
        >
            {`${new Date(now.getTime() + day * 24 * 60 * 60000).getDate()}. ${formatMonth(
                futureMonth(now, day),
                3
            )}`}
        </span>
    </>
);

DayText.defaultProps = {
    active: false,
    styles: {}
};

DayText.propTypes = {
    day: PropTypes.number.isRequired,
    now: PropTypes.instanceOf(Date).isRequired,
    active: PropTypes.bool,
    styles: PropTypes.shape({
        centerText: PropTypes.shape({})
    })
};

export default class DatePicker extends React.PureComponent {
    state = {
        active: 0
    };

    UNSAFE_componentWillMount() {
        if (days.length < daysBack + daysForward) {
            for (let i = -daysBack; i <= daysForward; i++) {
                days.push(i);
            }
        }
    }

    render() {
        const { active } = this.state;
        const { changeDate, now } = this.props;
        const offset = (active + 1) * this.styles.daySelectorContainer.width;

        return (
            <div
                style={this.styles.pickerContainer}
                ref={(ref) => {
                    if (ref) {
                        ref.scrollLeft = offset;
                    }
                }}
            >
                {days.map((day, i) => (
                    <>
                        <button
                            type="button"
                            key={`daypick${day}`}
                            style={{
                                ...this.styles.daySelectorContainer,
                                backgroundColor: day === active ? '#4b4b4b' : '#fff'
                            }}
                            onClick={() => {
                                const isLiveDay = day === 0;
                                const daysValue = isLiveDay ? 'live' : `${day} day/s`;
                                this.setState({ active: day });
                                const targetDate = new Date(now.getTime() + day * 24 * 60 * 60000);
                                logEvent({
                                    type: 'user-flow',
                                    subtype: 'epg',
                                    content1: 'epg-page',
                                    content2: daysValue,
                                    context: '/epg'
                                });
                                changeDate({
                                    filters: [
                                        {
                                            key: 'date',
                                            value: targetDate
                                        }
                                    ]
                                });
                                logEvent({
                                    type: 'navigation',
                                    subtype: 'epgFullDay',
                                    content1: targetDate.getTime(),
                                    content2: targetDate.toISOString()
                                });
                            }}
                        >
                            <DayText day={day} now={now} active={active} styles={this.styles} />
                        </button>
                        {i !== days.length - 1 && (
                            <div
                                style={{
                                    height: 24,
                                    width: 1,
                                    backgroundColor: '#D0D0D0',
                                    margin: 'auto 0'
                                }}
                            />
                        )}
                    </>
                ))}
            </div>
        );
    }

    styles = {
        pickerContainer: {
            position: 'relative',
            flexDirection: 'row',
            overflow: 'auto',
            display: 'flex',
            justifyContent: 'center',
            width: '100vw',
            zIndex: 0,
            backgroundColor: '#fff'
        },
        daySelectorContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flexShrink: 0,
            flexGrow: 0,
            paddingHorizontal: 15,
            width: 90,
            height: 60,
            borderWidth: 0,
            cursor: 'pointer'
        },
        centerText: {
            textAlign: 'center',
            width: '100%',
            fontFamily: Theme.thinFont
        }
    };
}

DatePicker.defaultProps = {
    active: false,
    styles: {},
    changeDate: () => {}
};

DatePicker.propTypes = {
    now: PropTypes.instanceOf(Date).isRequired,
    styles: PropTypes.shape({}),
    changeDate: PropTypes.func
};
